import { render, staticRenderFns } from "./maintenanceRegularList.vue?vue&type=template&id=5273a9c2&scoped=true"
import script from "./maintenanceRegularList.vue?vue&type=script&lang=js"
export * from "./maintenanceRegularList.vue?vue&type=script&lang=js"
import style0 from "./maintenanceRegularList.vue?vue&type=style&index=0&id=5273a9c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273a9c2",
  null
  
)

export default component.exports